import { TasquetMarkdownEditor } from '../../command';
const onTabDown = (e, editor) => {
    e.preventDefault();
    TasquetMarkdownEditor.indent(editor, e.shiftKey);
};
export default onTabDown;
//# sourceMappingURL=onTabDown.js.map